import React, { useState, useEffect } from "react";
import axiosInstance from './axiosInstance';

export function Project({ pname, selectedClient, selectedProject, onChange }) {
  const [projects, setProjects] = useState([]);

  // Fetch projects based on selected client
  useEffect(() => {
    if (selectedClient) {
      axiosInstance.post(`/getprojects`, { clientname: selectedClient })
        .then(res => setProjects(res.data))
        .catch(error => console.error(error));
    } else {
      setProjects([]);
    }
  }, [selectedClient]);

  return (
    <select
      className="w-[220px] h-[40px] flex justify-between items-center rounded-[22px] px-[10px] pl-[20px] border text-[15px] leading-none font-normal text-gray-700 bg-white font-poppins shadow-sm hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-primary-color"
      name="project"
      id="project"
      value={selectedProject || ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={!selectedClient}  // Disable if no client is selected
    >
      <option value="" disabled>Select Project</option>
      {projects.map(project => (
        <option key={project.project_name} value={project.project_name}>
          {project.project_name}
        </option>
      ))}
    </select>
  );
}
